var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearchIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    "aria-hidden": "true",
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.6172 14.4291L13.4445 11.2564C14.3491 10.0769 14.8867 8.60125 14.8867 7C14.8867 3.13401 11.7527 0 7.88672 0C4.02073 0 0.886719 3.13401 0.886719 7C0.886719 10.866 4.02073 14 7.88672 14C9.48797 14 10.9637 13.4624 12.1431 12.5577L15.3158 15.7305C15.6752 16.0898 16.2578 16.0898 16.6172 15.7305C16.9766 15.3711 16.9766 14.7885 16.6172 14.4291ZM13.0367 7C13.0367 9.84427 10.731 12.15 7.88672 12.15C5.04245 12.15 2.73672 9.84427 2.73672 7C2.73672 4.15573 5.04245 1.85 7.88672 1.85C10.731 1.85 13.0367 4.15573 13.0367 7Z",
    fill: "#151515",
    className: "hc-mode-search"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchIcon);
export default __webpack_public_path__ + "static/media/search-icon.9e6e4448153b50d9da26ce28fe54b872.svg";
export { ForwardRef as ReactComponent };